<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/** 解决宽高溢出出现滚动条的问题,并清除缺省的元素边距 */
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
/** 页面高度铺满浏览器*/
html,body { height: 100%;}
/** 页面主DIV高度铺满页面 */
#app{ height: 100%;}
</style>



// WEBPACK FOOTER //
// src/App.vue